import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { AbasSublinhado } from '../components/ui/iris';
import { AbaEventos } from '../components/auditoria/AbaEventos';
import { AbaTimeline } from '../components/auditoria/AbaTimeline';
import { AbaNumeros } from '../components/auditoria/AbaNumeros';
import { AbaUso } from '../components/auditoria/AbaUso';

type AbaId = 'eventos' | 'timeline' | 'numeros' | 'uso';

const ABAS = [
  { key: 'eventos' as const, label: 'Eventos' },
  { key: 'timeline' as const, label: 'Timeline' },
  { key: 'numeros' as const, label: 'Números' },
  { key: 'uso' as const, label: 'Uso' },
];

const AuditoriaPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  // Valor da URL e input externo (link velho, capitalizacao errada): cast cego
  // renderizaria painel em branco SEM aba sublinhada. Desconhecido cai em 'eventos'.
  const abaUrl = searchParams.get('aba');
  const aba: AbaId = ABAS.some(a => a.key === abaUrl) ? (abaUrl as AbaId) : 'eventos';

  // Deep-link por querystring (não hash): a Timeline precisa carregar
  // entidade+id no mesmo link, e link de investigação é pra ser colado no chat.
  const irPara = (id: AbaId) => setSearchParams(prev => {
    const p = new URLSearchParams(prev);
    p.set('aba', id);
    return p;
  }, { replace: true });

  return (
    // Mock Íris: conteúdo limitado a 1280px centralizado. h-full + flex-col
    // preserva a cadeia de altura que a AbaEventos usa pra rolar a tabela
    // internamente (ver AbaEventos.tsx) — não copiar o space-y-4 sem h-full
    // que OrganizacaoPage/UsuariosPage usam, senão o scroll interno quebra.
    <div className="flex h-full w-full max-w-[1280px] mx-auto flex-col gap-3">
      {/* Header (mock: sem ícone) */}
      <div>
        <h1 className="text-[22px] font-bold text-tx tracking-[-0.02em]">Auditoria</h1>
        <p className="text-[13.5px] text-tx-3 mt-0.5">Histórico de eventos e atividades do sistema.</p>
      </div>

      <AbasSublinhado<AbaId> className="shrink-0" abas={ABAS} ativa={aba} onChange={irPara} />

      {/* min-h-0 é o que faz o flex item encolher — sem ele a tabela empurra a página. */}
      <div className="flex-1 min-h-0">
        {aba === 'eventos' && <AbaEventos />}
        {aba === 'timeline' && <AbaTimeline />}
        {aba === 'numeros' && <AbaNumeros />}
        {aba === 'uso' && <AbaUso />}
      </div>
    </div>
  );
};

export default AuditoriaPage;
